import CarrierLogoSameSize from '@components/molecules/CarrierLogoSameSize';
import DefaultTable from '@components/molecules/table/DefaultTable';
import {
  bancos,
  calculateVehicleLoanMensalidade,
  calculateVehicleLoanTotal,
} from '@lib/data/loan';
import { useIsSmall } from '@lib/hooks/mediaQuery';
import { integerToCurrency } from 'helpers';
import React from 'react';
import styled from 'styled-components';

const Table = styled.table`
  width: 100%;

  tr {
    display: flex;
    position: relative;
    flex-direction: column;
    padding-top: 1em;
    padding-bottom: 1em;

    &:before {
      content: '';
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      width: calc(100% - 8 * 8);
      height: 1px;
      background: #ccd6f5;
    }

    td {
      display: flex;
      justify-content: space-between;
      padding-top: 4px;
      padding-right: 0;
      padding-left: 0;
      padding-bottom: 4px;
      border: none;
      color: var(--color-content-secondary);
      line-height: 16px;
      align-items: center;

      p,
      strong {
        margin: 0;
        padding: 0;
      }

      p {
        font-size: 13px;
      }
    }
  }
`;

export default function AutoLoanRatesList({
  total,
  meses,
  entrada,
}: {
  total: number;
  meses: number;
  entrada: number;
}) {
  const isSmall = useIsSmall();

  if (isSmall)
    return (
      <Table>
        <tbody>
          {bancos.map((banco) => (
            <tr className="" key={banco.InstituicaoFinanceira}>
              <td>
                <CarrierLogoSameSize
                  name={`Financiamento ${banco.nome}`}
                  logoUrl={banco.logoPng}
                />
              </td>

              {[
                {
                  key: 'Nome',
                  label: banco.nome,
                },
                {
                  key: 'Nota ReclameAqui',
                  label: banco.reclameAquiScore,
                },
                {
                  key: 'Taxa de Juros',
                  label: `${(banco.TaxaJurosAoAno * 100).toFixed(2)}% (a.a)`,
                },
                {
                  key: 'Total Financiado',
                  label: integerToCurrency(
                    calculateVehicleLoanTotal(
                      total - entrada,
                      meses,
                      banco.TaxaJurosAoMes,
                    ),
                  ),
                },
                {
                  key: 'Valor Parcela',
                  label: integerToCurrency(
                    calculateVehicleLoanMensalidade(
                      total - entrada,
                      meses,
                      banco.TaxaJurosAoMes,
                    ),
                  ),
                  big: true,
                },
              ].map(({ key, label, big }) => (
                <React.Fragment key={key}>
                  <td>
                    <p>{key}</p>
                    <strong
                      style={{
                        fontSize: big ? '1.5em' : undefined,
                      }}
                    >
                      {label}
                    </strong>
                  </td>
                </React.Fragment>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    );

  return (
    <DefaultTable
      heads={[
        'Instiuição Financeira',
        'Nota ReclameAqui',
        'Taxa de Juros',
        'Total Financiado',
        'Valor Parcela',
      ]}
      rows={bancos.map((banco) => [
        <CarrierLogoSameSize
          key={banco.InstituicaoFinanceira}
          name={`Financiamento ${banco.nome}`}
          logoUrl={banco.logoPng}
        />,
        banco.reclameAquiScore,
        `${(banco.TaxaJurosAoAno * 100).toFixed(2)}% (a.a)`,
        integerToCurrency(
          calculateVehicleLoanTotal(
            total - entrada,
            meses,
            banco.TaxaJurosAoMes,
          ),
        ),
        integerToCurrency(
          calculateVehicleLoanMensalidade(
            total - entrada,
            meses,
            banco.TaxaJurosAoMes,
          ),
        ),
      ])}
    />
  );
}
